import { GenericList } from '.'

interface ICacheItem {
  key: string;
  value: GenericList
}

export class GenericListCache {
  list: ICacheItem[] = [];
  maxSize: number;

  constructor(maxSize: number) {
    this.maxSize = maxSize;
  }

  get<T>(key: string) {
    const list = this.list.find((item) => item.key === key)?.value;

    return list ? list as GenericList<T> : undefined;
  }

  getOrCreate<T>(key: string, creator: () => GenericList<T>) {
    return (this.list.find((item) => item.key === key)?.value ?? this.set(key, creator)) as GenericList<T>;
  }

  set(key: string, creator: () => GenericList) {
    const list = creator();
    const index = this.list.findIndex((item) => item.key === key);

    if (index !== -1) {
      this.list[index].value = list;
    } else {
      if (this.list.length === this.maxSize) {
        this.list.shift();
      }
      this.list.push({ key: key, value: list });
    }

    return list;
  }

  remove(key: string) {
    const index = this.list.findIndex((item) => item.key === key);

    if (index !== -1) {
      this.list.splice(index, 1);
    }
  }
}